var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TakingAddForm',{ref:"form",model:{value:(_vm.create),callback:function ($$v) {_vm.create=$$v},expression:"create"}}),_c('button',{staticClass:"vca-button",on:{"click":function($event){return _vm.add()}}},[_vm._v(" "+_vm._s(_vm.$t("button.save"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }